import { render, staticRenderFns } from "./CleanGover.vue?vue&type=template&id=1138b8b0&scoped=true"
import script from "./CleanGover.vue?vue&type=script&lang=js"
export * from "./CleanGover.vue?vue&type=script&lang=js"
import style0 from "./CleanGover.vue?vue&type=style&index=0&id=1138b8b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1138b8b0",
  null
  
)

export default component.exports